export const environment = {
	baseUrl: 'https://grupostudium-crm-stg.gainkodex.com',
	production: false,
	// Staging keeps the "Firmar simulado" bypass for testing without a tablet.
	allowSimulatedSign: true,
	// No dev quick-login outside local development.
	devLogin: null as { id: string; email: string; password: string }[] | null,
	pathBackend: 'https://grupostudium-crm-stg.gainkodex.com/api/v1',
	get API_URL(): string {
		return this.pathBackend;
	},
};
